"use client";

import { cn } from "@kyan/ui";

import { AppNotice } from "./components/AppNotice/AppNotice";
import { useAppNoticeController } from "./components/AppNotice/AppNotice.controller";
import { LiquidationWarnings } from "./components/LiquidationWarnings/LiquidationWarnings";
import { useLiquidationWarningsController } from "./components/LiquidationWarnings/LiquidationWarnings.controller";
import { RemoteNotice } from "./components/RemoteNotice/RemoteNotice";
import { SystemAlerts } from "./components/SystemAlerts/SystemAlerts";
import { useSystemAlertsController } from "./components/SystemAlerts/SystemAlerts.controller";

export interface AlertsHubProps {
  className?: string;
}

export const AlertsHub: React.FC<AlertsHubProps> = ({ className }) => {
  const { isInvisible: isAppNoticeInvisible } = useAppNoticeController();
  const { areAlertsInvisible } = useLiquidationWarningsController();
  const { areSystemAlertsInvisible } = useSystemAlertsController();

  const hideBanners =
    isAppNoticeInvisible && areAlertsInvisible && areSystemAlertsInvisible;

  return (
    <>
      {!hideBanners && (
        <div className={cn("flex flex-col gap-4", className)}>
          <LiquidationWarnings />
          <AppNotice />
          <SystemAlerts />
        </div>
      )}

      <RemoteNotice className={className} />
    </>
  );
};
